<template>
  <div class="control-head" :style="{ '--accent': accent }">
    <div class="controls-row">

      <!-- Left: your filter controls -->
      <slot />

      <!-- Growing spacer: pushes the actions right on a full row, but stays
           behind on that row when the actions wrap — so the button then starts
           at the LEFT of its own line instead of staying right. -->
      <div class="controls-spacer" aria-hidden="true"></div>

      <!-- Right: actions area (optional) -->
      <div class="controls-actions" v-if="$slots.actions">
        <slot name="actions" />
      </div>

      <!-- Back-compat: optional built-in Allen's button (off by default) -->
      <button
        v-else-if="showDefaultInsightsButton"
        class="toggle-popup"
        @click="$emit('insights')"
      >
        <i class="bi bi-lightning-charge"></i> {{ insightsLabel || $t('zoneDetail.allenInsights') }}
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  accent: { type: String, default: 'var(--stora-accent)' },

  // Back-compat props: prefer using <slot name="actions"> instead.
  showDefaultInsightsButton: { type: Boolean, default: false },
  // empty = "Allen's Insights" in the reader's language
  insightsLabel: { type: String, default: '' },
})
defineEmits(['insights'])
</script>